import { CSSProperties } from 'react';
import { Theme } from '@mui/material/styles';
import { ColorKeyPerMatch } from '@/pages/Candidate/view/utils/DecisionTreeDiagram/nodes/ColorKeyPerMatch/types';
import { TURN_STYLES } from '@/styles/theme';

export const BG_COLOR_KEY_MAPPING: Record<ColorKeyPerMatch, { styles: (theme: Theme) => CSSProperties }> = {
  dark_amber: {
    styles: (theme) => ({
      padding: '20px 4px',
      backgroundColor: theme.palette.mode === 'dark' ? TURN_STYLES.darkWarningLight : '#FFE8C2',
      color: theme.palette.mode === 'dark' ? TURN_STYLES.darkWarningDark : '#8A4B00',
      border: theme.palette.mode === 'dark' ? 'none' : '1px solid #FFD89A',
    }),
  },
  dark_green: {
    styles: (theme) => ({
      padding: '20px 4px',
      backgroundColor: theme.palette.mode === 'dark' ? TURN_STYLES.darkSuccessLight : '#D6F0E2',
      color: theme.palette.mode === 'dark' ? TURN_STYLES.darkSuccessDark : '#1B5E20',
      border: theme.palette.mode === 'dark' ? 'none' : '1px solid #C1E6D3',
    }),
  },
  dark_grey: {
    styles: (theme) => ({
      padding: '20px 4px',
      backgroundColor: theme.palette.mode === 'dark' ? TURN_STYLES.darkNeutralLight : '#E5E7EB',
      color: theme.palette.mode === 'dark' ? TURN_STYLES.darkNeutralDark : '#374151',
      border: theme.palette.mode === 'dark' ? 'none' : '1px solid #D1D5DB',
    }),
  },
  light_grey: {
    styles: (theme) => ({
      padding: '20px 4px',
      backgroundColor: theme.palette.mode === 'dark' ? TURN_STYLES.darkNeutralLight : '#EEEEEE',
      color: theme.palette.mode === 'dark' ? TURN_STYLES.darkNeutralDark : 'rgb(0 0 0)',
      border: theme.palette.mode === 'dark' ? 'none' : '1px solid #D1D5DB',
    }),
  },
  red: {
    styles: (theme) => ({
      padding: '20px 4px',
      backgroundColor: theme.palette.mode === 'dark' ? TURN_STYLES.darkErrorLight : '#FAD7D4',
      color: theme.palette.mode === 'dark' ? TURN_STYLES.darkErrorDark : '#8E1E1E',
      border: theme.palette.mode === 'dark' ? 'none' : '1px solid #F4B8B5',
    }),
  },
};
